import { api } from 'API';
import { ACTIVITY_TYPE } from 'Enum/ActivitiesLobby';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/SearchLobby';

interface IAnalyticsData {
  componentName: string;
  eventName: string;
  label: string;
}

interface ISearchWord {
  id: number;
  text: string;
}

export interface IActivity {
  id: number;
  label: string;
  link: string;
  analyticsData: IAnalyticsData;
  searchWords: ISearchWord[];
  activityTypeId: ACTIVITY_TYPE;
}

export interface IActivityCategory {
  id: number;
  title: string;
  activities: IActivity[];
  activityTypeId: number;
}

export const getActivities = async () => {
  const activitiesResult = await api.get<IActivityCategory[]>(
    addImposterToUrl(baseUrl, true)
  );
  if (activitiesResult.data) {
    return activitiesResult.data;
  }
};

export const getFileSource = async (url: string) => {
  const fileResponse = await api.get<{ file: string }>(
    addImposterToUrl(url, true)
  );

  if (fileResponse.data?.file) return fileResponse.data.file;
};
